import { useState } from 'react';

const allTestimonials = [
  {
    id: 1,
    name: '林小姐',
    role: '育兒家庭',
    category: '家庭保障規劃',
    categoryColor: '#5C5470',
    quote: '保險建築師幫我們規劃了完整家庭醫療與風險保障方案，讓我安心許多。從孩子的醫療保障到先生的收入保障，每一個環節都考慮得非常周全。',
    highlight: '完整家庭醫療與風險保障',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20young%20mother%20portrait%20warm%20smile%20elegant%20casual%20attire%20clean%20light%20background%20studio%20photography&width=200&height=200&seq=client001&orientation=squarish',
  },
  {
    id: 2,
    name: '張先生',
    role: '科技業工程師',
    category: '個人醫療保險',
    categoryColor: '#FF8C69',
    quote: '專業、耐心，詳細分析保單缺口，真的非常值得信任。原本以為自己的保障已經夠了，健檢後才發現有幾個重要缺口，調整後安心很多。',
    highlight: '詳細分析保單缺口',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20engineer%20portrait%20confident%20smile%20smart%20casual%20attire%20clean%20background%20studio%20photography&width=200&height=200&seq=client002&orientation=squarish',
  },
  {
    id: 3,
    name: '王經理',
    role: '金融業主管',
    category: '保單健檢與缺口分析',
    categoryColor: '#D4A373',
    quote: '量身設計的保險規劃，兼顧資產防護與風險管理，非常專業。琮恩能用清楚的邏輯說明每一個決策背後的原因，讓我很有信心。',
    highlight: '兼顧資產防護與風險管理',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20financial%20manager%20portrait%20confident%20mature%20smile%20formal%20attire%20clean%20background%20studio%20photography&width=200&height=200&seq=client003&orientation=squarish',
  },
  {
    id: 4,
    name: '陳太太',
    role: '家庭主婦',
    category: '家庭保障規劃',
    categoryColor: '#5C5470',
    quote: '家庭風險設計讓我們全家都感到安全，未來醫療與財務都有保障。最讓我感動的是，琮恩不只是賣保單，而是真的在乎我們家的狀況。',
    highlight: '全家都感到安全',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20middle%20age%20housewife%20portrait%20warm%20smile%20casual%20attire%20clean%20light%20background%20studio%20photography&width=200&height=200&seq=client004&orientation=squarish',
  },
  {
    id: 5,
    name: '李總監',
    role: '中小企業負責人',
    category: '企業團體方案',
    categoryColor: '#FF8C69',
    quote: '感謝保險建築師，為我們公司設計了企業團體方案，員工福利提升很多。同事們都說公司更有溫度了，對留才也有明顯幫助。',
    highlight: '員工福利顯著提升',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20business%20director%20portrait%20confident%20smile%20formal%20business%20attire%20clean%20background%20studio%20photography&width=200&height=200&seq=client005&orientation=squarish',
  },
  {
    id: 6,
    name: '吳先生',
    role: '自由工作者',
    category: '個人醫療保險',
    categoryColor: '#FF8C69',
    quote: '個人醫療保險規劃非常細緻，針對我的需求制定專屬方案。身為自由工作者，沒有公司保險，這次規劃讓我終於有了完整的醫療保障。',
    highlight: '自由工作者專屬保障方案',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20freelancer%20portrait%20relaxed%20smile%20casual%20attire%20clean%20background%20studio%20photography&width=200&height=200&seq=client006&orientation=squarish',
  },
  {
    id: 7,
    name: '黃小姐',
    role: '護理師',
    category: '保單健檢與缺口分析',
    categoryColor: '#D4A373',
    quote: '保單健檢服務非常專業，找出保障缺口並提出最適合的調整方向。雖然我在醫療業工作，但對自己的保障反而不夠了解，這次健檢讓我受益良多。',
    highlight: '找出保障缺口並提出調整方向',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20nurse%20healthcare%20worker%20portrait%20warm%20smile%20scrubs%20clean%20background%20studio%20photography&width=200&height=200&seq=client007&orientation=squarish',
  },
  {
    id: 8,
    name: '蔡先生',
    role: '會計師',
    category: '保單健檢與缺口分析',
    categoryColor: '#D4A373',
    quote: '顧問分析清楚，讓我更了解保險與整體財務規劃整合的重要性。作為會計師，我很重視數字與邏輯，琮恩的分析方式讓我非常信服。',
    highlight: '保險與財務規劃整合',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20accountant%20portrait%20confident%20smile%20formal%20attire%20glasses%20clean%20background%20studio%20photography&width=200&height=200&seq=client008&orientation=squarish',
  },
  {
    id: 9,
    name: '劉太太',
    role: '新婚家庭',
    category: '家庭保障規劃',
    categoryColor: '#5C5470',
    quote: '專業又親切，整個規劃過程讓我們全家都放心。剛結婚時對保險一竅不通，琮恩用很有耐心的方式帶我們一步步了解，完全沒有壓力。',
    highlight: '耐心陪伴，全程無壓力',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20young%20married%20woman%20portrait%20warm%20smile%20elegant%20attire%20clean%20light%20background%20studio%20photography&width=200&height=200&seq=client009&orientation=squarish',
  },
  {
    id: 10,
    name: '許先生',
    role: '退休規劃族',
    category: '保單健檢與缺口分析',
    categoryColor: '#D4A373',
    quote: '每年檢視與更新方案，確保保障有效且長期穩定，非常值得信任。琮恩不只是在我買保單時出現，而是每年都主動聯繫，讓我感受到真正的長期服務。',
    highlight: '每年主動追蹤，長期陪伴',
    stars: 5,
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20middle%20age%20retirement%20planning%20portrait%20confident%20smile%20casual%20attire%20clean%20background%20studio%20photography&width=200&height=200&seq=client010&orientation=squarish',
  },
];

const filterTabs = ['全部', '家庭保障規劃', '個人醫療保險', '保單健檢與缺口分析', '企業團體方案'];

export default function TestimonialsCards() {
  const [activeFilter, setActiveFilter] = useState('全部');

  const filtered = activeFilter === '全部'
    ? allTestimonials
    : allTestimonials.filter((t) => t.category === activeFilter);

  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            CLIENT STORIES
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            精選客戶見證
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4"></div>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap gap-3 justify-center mb-12">
          {filterTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveFilter(tab)}
              className={`px-5 py-2.5 rounded-full font-medium whitespace-nowrap transition-all duration-200 cursor-pointer
                ${activeFilter === tab
                  ? 'bg-[#5C5470] text-white'
                  : 'bg-[#F8F5F0] border border-gray-200 text-gray-600 hover:border-[#5C5470] hover:text-[#5C5470]'
                }`}
              style={{ fontSize: '1.0625rem' }}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {filtered.map((t) => (
            <article
              key={t.id}
              className="bg-white border border-gray-100 rounded-2xl p-7 flex flex-col hover:border-[#D4A373]/40 hover:-translate-y-1 transition-all duration-300"
              style={{ boxShadow: '0 2px 16px 0 rgba(92,84,112,0.06)' }}
            >
              {/* Quote icon */}
              <i className="ri-double-quotes-l text-[#D4A373]/30 text-5xl mb-3 block"></i>

              {/* Category badge */}
              <span
                className="inline-block px-3 py-1 rounded-full text-white font-medium mb-4 self-start"
                style={{ fontSize: '1rem', backgroundColor: t.categoryColor }}
              >
                {t.category}
              </span>

              {/* Highlight */}
              <p
                className="font-serif font-bold text-[#5C5470] mb-3"
                style={{ fontSize: 'clamp(1.125rem, 1.4vw, 1.25rem)', lineHeight: '1.45' }}
              >
                「{t.highlight}」
              </p>

              {/* Quote */}
              <p
                className="text-gray-600 flex-1 mb-6"
                style={{ fontSize: '1.0625rem', lineHeight: '1.8' }}
              >
                {t.quote}
              </p>

              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D4A373]" style={{ fontSize: '1.0625rem' }}></i>
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-gray-100">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.img}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-semibold text-[#5C5470]" style={{ fontSize: '1.0625rem' }}>
                    {t.name}
                  </p>
                  <p className="text-gray-400" style={{ fontSize: '1rem' }}>{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
